import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { recursosBecas } from 'src/app/recursos/interfaz';
import { toString } from '@ng-bootstrap/ng-bootstrap/util/util';

@Component({
  selector: 'app-estudio-socio-ec-revisa',
  templateUrl: './estudio-socio-ec-revisa.component.html',
  styleUrls: ['./estudio-socio-ec-revisa.component.css']
})
export class EstudioSocioEcRevisaComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsGen: DataTables.Settings = {};
  dtOptionsEsp: DataTables.Settings = {};
  public dtTriggerGen: Subject<any>;
  public dtTriggerEsp: Subject<any>;

  public nombreBeca: string = ""; public vecPeriodo = []; public vecEstudio = []; public periodoBuscar: string = '';
  public rutaCarga: SafeResourceUrl | undefined; public enlaceCarga: string = ''; private tokenDrive: any;
  public vecObservacion = [];

  constructor(private modalService: NgbModal, private tools: ToolsService, private srvSelect: SeleccionService, private alerti: AlertifyService,
    private srvGeneral: recursosCompartido, private srvInsert: IngresoService, private recBecas: recursosBecas, private sanitizer: DomSanitizer, private cargando: LoaderComponent) { }

  async ngOnInit() {
    this.nombreBeca = localStorage.getItem('modNom');

    this.dtTriggerEsp = new Subject<any>();
    this.dtOptionsEsp[0] = this.tools.OpcionesTabla(10);
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
    this.instanciaVecObserva('', '', '', '', '', '', 0);
    this.cargarPeriodos();
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = []; this.periodoBuscar = '';
    //OBTENER LOS PERIODO ACADÉMICOS DE LA MASTER
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.periodoBuscar = res.carrera[0]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
  }
  //FUNCION PARA ABRIR EL MODAL MUESTRA LOS PERIODOS ACADÉMICOS
  modalVerPeriodos(nameMod) {
    if (localStorage.getItem('modUser') == 'true')
      this.mr = this.modalService.open(nameMod);
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //VER EL LISTADO DE ESTUDIOS SOCIO ECONÓMICOS
  async verEstudiosSocioEconomicos() {
    this.vecEstudio = [];
    var table3 = $('#tblEspecifico').DataTable({
      destroy: true
    });
    table3.destroy();

    const resEstudio = await new Promise<any>(resolve => this.srvSelect.gestionSocioEconomico(8, this.periodoBuscar, 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    if (resEstudio.resultado)
      this.vecEstudio = resEstudio.socioEconomico;
    else
      this.alerti.error('No se encontraron registros');
    this.cerrarModal();
    this.dtTriggerEsp.next();
    console.log(this.vecEstudio);
  }
  //MODAL PARA VER EL DOCUMENTO ENVIADO POR LA ANALISTA
  verArchivoCarga(nombModal, dataEstudio, opc) {
    console.log('--------------------------', dataEstudio);

    if (localStorage.getItem('modUser') == 'true') {
      if (dataEstudio.enviado > 0) {
        this.mr = this.modalService.open(nombModal);
        this.verObservacionEstudioSocioEc(dataEstudio, opc);
      }
      else
        this.alerti.error("El documento no ha sido enviado para su revisión");
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE CARGA EL PDF Y OBSERVACIONES DEL ESTUDIO SOCIO ECONOMICO
  async verObservacionEstudioSocioEc(estudioSocioEc, op) {
    const resEstudio = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(7, estudioSocioEc.intIdRegistro, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEstudio.resultado) {
      this.instanciaVecObserva(resEstudio.socioEconomico[0]['intIdObserva'], resEstudio.socioEconomico[0]['strDetalle'], resEstudio.socioEconomico[0]['strRuta'],
        resEstudio.socioEconomico[0]['intRegistro'], resEstudio.socioEconomico[0]['dtFecha'], resEstudio.socioEconomico[0]['strRegistro'], resEstudio.socioEconomico[0]['intEstado']);
      if (op == 1) {
        this.rutaCarga = await this.srvGeneral.obtenerArchivoPDF(this.tokenDrive, resEstudio.socioEconomico[0]['strRuta']);
        this.enlaceCarga = await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, resEstudio.socioEconomico[0]['strRuta']);
      }
      else {
        console.log(resEstudio.socioEconomico);
        console.log(this.vecObservacion)
      }
    }
  }
  //GUARDA LAS OBSERVACIONES REALIZADAS A UN ESTUDIO SOCIO ECONOMICO FUNCION EN EL BOTON
  guardarObservacion() {
    this.registroObservacion(this.vecObservacion[0]['strDetalle'], this.vecObservacion[0]['strRuta'], this.vecObservacion[0]['intRegistro'],
      localStorage.getItem('ciUsuario'), this.vecObservacion[0]['intEstado'], 2);
  }
  //INGRESA LAS OBSERVACIONES REALIZADAS A UN ESTUDIO SOCIO ECONOMICO
  registroObservacion(dato1, dato2, dato3, dato4, dato5, op) {
    this.srvInsert.ingresoSocioEconomico(dato1, dato2, dato3, dato4, dato5, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 4).subscribe(res => {
      if (res.encuesta) {
        this.alerti.success('Archivo enviado con éxito');
        if (op == 1)
          window.location.reload();
      }
    });
  }
  //INSTANCIAR EL VECTOR DE LAS OBSERVACIONES
  instanciaVecObserva(dato1, dato2, dato3, dato4, dato5, dato6, dato7) {
    this.vecObservacion = [];
    this.vecObservacion.push({ intIdObserva: dato1, strDetalle: dato2, strRuta: dato3, intRegistro: dato4, dtFecha: dato5, strRegistro: dato6, intEstado: dato7 })
  }

  //HCER LA PETICION AL TRANSVERSAL DE FIRMAEC DESDE EL BOTON DEL MODAL
  async firmarArchivo() {
    let dataPDF = await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, this.vecObservacion[0].strRuta);
    let pdf64 = await this.srvGeneral.toDataURL(dataPDF);
    let vecCertificados = []; let urlFrima = '';
    let Firmax = 435; let Firmay = 183; let numPagina = 1
    vecCertificados.push({ 'nombre': this.recBecas.nombreArchFirma, 'archivo': pdf64.toString().replace('data:application/pdf;base64,', '') });
    var content = {
      'idAplicacion': this.recBecas.idAplicacion,
      'jwtsecret': this.recBecas.claveAplicacion,
      'activo': 'true',
      'cedula': localStorage.getItem('ciUsuario'),
      'listado': vecCertificados
    };
    const datos = await new Promise<any>((resolve) => this.srvInsert.FirmarEc(this.tokenDrive, content).subscribe((translated) => { resolve(translated); }));
    if (datos.success) {
      urlFrima = "firmaec://" + this.recBecas.apiKeyFirma + "/firmar?token=" + datos.data + "&tipo_certificado=2%26llx%3D" + Firmax + "%26lly%3D"
        + Firmay + "%26pagina%3D" + numPagina + "%26estampado%3DQR%26url%3Dhttp%3A%2F%2Fapifirmaec.espoch.edu.ec%2Fapi%26razon%3Dfirmado%20desde%20https%3A%2F%2Fsai.espoch.edu.ec";
      window.open(urlFrima, '_blank');
    }
  }

  async subirArchivo() {
    this.cargando.abrir();
    let archivoFile: any;
    const resFirma = await new Promise<any>((resolve) => this.srvInsert.obtener64Firmado(this.tokenDrive).subscribe((translated) => { resolve(translated); }));
    if (resFirma.success) {
      this.rutaCarga = await this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + resFirma.listado[0].archivoFirmado);
      archivoFile = await this.srvGeneral.dataURItoBlob(resFirma.listado[0].archivoFirmado, 'documentoFirmado.pdf');//OBTENGO EL FILE
      await this.subirPDFDrive(archivoFile);
    }
  }

  async subirPDFDrive(archivo) {
    let frmArchivo = new FormData();
    let rutaCarga = this.vecObservacion[0].strRuta;
    frmArchivo.append('idAplicacion', this.recBecas.idAplicacion);
    frmArchivo.append('idCredencial', "1");
    frmArchivo.append('activo', "true");
    frmArchivo.append('ruta', rutaCarga);
    frmArchivo.append('file', archivo);
    await this.srvInsert.subirArchivos(frmArchivo, this.tokenDrive).subscribe(resSubir => {
      if (resSubir.success)
        this.registroObservacion('', this.vecObservacion[0]['strRuta'], this.vecObservacion[0]['intRegistro'], localStorage.getItem('ciUsuario'), 1, 1);
    });
    this.cargando.cerrar();
  }

  cerrarModal() {
    this.mr.close();
  }
}
